import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idBancoPagamento: number | null, openState: boolean) => void,
    onActionDelete: (idBancoPagamento: number | null, openState: boolean) => void,

}

export const GenerateBancoPagamentoListaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {

    //#region  STATUS
    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Inativo";
            case 1:
                return "Ativo";
            default: // OUTROS
                return "D";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0:
                return "red";
            case 1: // ATIVO
                return "green";
            default: // OUTROS
                return "blue";

        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0: // INATIVO
                return "Inativo";
            case 1: // ATIVO
                return "Ativo";
            default: // OUTROS
                return "Não se aplica";

        };
    };
    //#endregion




    //#region  CONTROLA SALDO

    const computeControlaSaldoTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Não";
            case 1:
                return "Sim";
            default:
                return "D";
        }
    };

    const computeControlaSaldoColor = (status: number) => {
        switch (status) {
            case 0:
                return "red";
            case 1:
                return "green";
            default:
                return "blue";

        }
    };

    //#endregion





    return [
        {
            field: "ativo",
            filterable: false,
            headerName: "Status",
            minWidth: 75,
            width: 75,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size='autowidth'
                        title={computeItemStatusTitle(params.value ? 1 : 0)}
                        color={computeItemStatusColor(params.value ? 1 : 0)}
                        description={computeItemStatusDescription(params.value ? 1 : 0)} />
                </div>
            )
        },
        {
            field: "controlaSaldo",
            filterable: false,
            headerName: "Controla Saldo?",
            minWidth: 75,
            width: 75,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        title={computeControlaSaldoTitle(params.value === true ? 1 : 0)}
                        color={computeControlaSaldoColor(params.value === true ? 1 : 0)}
                        description={''}

                    />
                </div>
            )
        },

        {
            field: "nomeBanco",
            filterable: false,
            headerName: "Nome do Banco",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "nrAgencia",
            filterable: false,
            headerName: "N° da Agência",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "nrConta",
            filterable: false,
            headerName: "N° da Conta",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: 'idBancoPagamento',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}